<template>
    <el-drawer size="90%" :visible.sync="dialogVisible" :wrapperClosable="false" @close="close" :show-close="false">
        <section slot="title" class="dialog-top">
            <p>{{ $t('invoicesCenter.detailTitle') }}</p>
            <div style="display: flex">
                <div class="sub-box" @click="checkGet()" v-if="type == 1 && [9, 10, 11].includes(+modalParams.state)">
                    <svg-icon class-name="size-icon" icon-class="acceptance" /> {{ $t('invoicesCenter.detailStartaccept') }}
                </div>
                <div class="sub-box" @click="checkAcceptClick" v-if="type == 2 && [4, 5].includes(+modalParams.state)">
                    <svg-icon class-name="size-icon" icon-class="picking" /> {{ $t('invoicesCenter.detailStartpick') }}
                </div>
                <i class="el-icon-close" @click="dialogVisible = false"></i>
            </div>
        </section>
        <section v-loading="loading" style="padding-bottom: 20px">
            <section class="step">
                <!-- <el-steps :active="scheduleState" finish-status="finish" process-status="wait" align-center>
                    <el-step
                        v-for="(item, index) in scheduleInfoList"
                        :key="item.sort"
                        :title="item.invoicesName"
                        :status="item.hasNowStep === 'N' ? 'wait' : ''"
                    >
                        <div slot="description" v-if="item.hasNowStep === 'Y'">
                            <div>{{ item.startTime }}</div>
                            <div v-if="item.consumingTime && index > 0" style="color: #999">
                                耗时：{{ item.consumingTime }}
                            </div>
                            <span v-if="item.timeout" style="color: red">超时：{{ item.overTime }}</span>
                        </div>
                    </el-step>
                </el-steps> -->
                <Timeline :timeList="scheduleInfoList"></Timeline>
            </section>
            <section class="section-card">
                <h3 class="section-title">
                    <span></span>
                    <div>{{ $t('invoicesCenter.detailInvoiceinfo') }}</div>
                </h3>
                <div class="section-value" v-if="invoicesData">
                    <el-descriptions :column="4" size="small" border style="width: 100%">
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.detailCreator') }} </template>
                            {{ invoicesData.createUserName }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.detailSender') }} </template>
                            {{ invoicesData.outMarketName }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.detailReceiver') }} </template>
                            {{ invoicesData.inMarketName }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label">
                                <!-- {{
                                    drawerType == 2 || drawerType == 3
                                        ? '调拨数量'
                                        : drawerType == 5
                                        ? '退仓数量'
                                        : drawerType == 6
                                        ? '退供数量'
                                        : '铺货数量'
                                }} -->
                                {{ $t('invoicesCenter.detailTransfernum') }}
                            </template>
                            {{ invoicesData.totalNum }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.detailOutnum') }} </template>
                            {{ invoicesData.outNum }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.detailInnum') }} </template>
                            {{ invoicesData.inNum }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.detailOutdiffnum') }} </template>
                            {{ invoicesData.outNumDifference }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.detailIndiffnum') }} </template>
                            <!-- {{ invoicesData.storageDifferenceCount }} -->
                            {{ invoicesData.inNumDifference }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.detailCreatetime') }} </template>
                            {{ invoicesData.createTime }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.detailUpdatetime') }} </template>
                            {{ invoicesData.updateTime }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.detailLastmodifier') }} </template>
                            {{ invoicesData.updateUserName }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.detailTotaltime') }} </template>
                            {{ invoicesData.totalTime }}
                        </el-descriptions-item>
                        <el-descriptions-item v-if="invoicesData.goodsPrincipal && drawerType != 2">
                            <template slot="label"> {{ $t('invoicesCenter.detailGoodsmanager') }} </template>
                            {{ invoicesData.goodsPrincipal }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.detailRemark') }} </template>
                            {{ invoicesData.remark }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.detailDiffreason') }} </template>
                            {{ invoicesData.difReason }}
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
                <div class="detail-state" v-if="invoicesData">
                    <StatusTag v-if="invoicesData.state == 0" type="void" />
                    <StatusTag v-if="invoicesData.state == 4" type="sended" />
                    <StatusTag v-if="invoicesData.state == 5" type="orderpack" />
                    <StatusTag v-if="invoicesData.state == 6" type="orderpacked" />
                    <StatusTag v-if="invoicesData.state == 7" type="packing" />
                    <StatusTag v-if="invoicesData.state == 8" type="packed" />
                    <StatusTag v-if="invoicesData.state == 9" type="outed" />
                    <StatusTag v-if="invoicesData.state == 10" type="checked" />
                    <StatusTag v-if="invoicesData.state == 14" type="joined" />
                </div>
            </section>

            <section class="section-card">
                <h3 class="section-title">
                    <span></span>
                    <div>{{ $t('invoicesCenter.detailProductlist') }}</div>
                </h3>
                <div>
                    <SizeGroupTable
                        ref="sizeGroupTableIns"
                        :dataList="dataList"
                        :columns="newColumns"
                        :isEmpty="true"
                        :sizeInfoLabels="newSizeInfoLabels"
                        :footerOptions="newFooterOptions"
                        border
                    >
                        <template v-slot="{ row, item }">
                            <el-popover v-if="item.prop === 'goodsNo'" placement="right-start" trigger="click">
                                <el-image
                                    v-if="row.imageList && row.imageList.length"
                                    style="width: 400px; height: 400px"
                                    :src="row.imageList[0]"
                                    :preview-src-list="row.imageList"
                                >
                                </el-image>
                                <span slot="reference" class="text-link">{{ row.goodsNo }} </span>
                            </el-popover>
                        </template>
                    </SizeGroupTable>
                </div>
            </section>

            <section class="section-card" v-if="logisticsList.length">
                <h3 class="section-title">
                    <span></span>
                    <div>{{ $t('invoicesCenter.detailDeliveryinfo') }}</div>
                </h3>
                <div style="margin: 20px">
                    <el-table
                        border
                        :data="logisticsList"
                        :header-cell-style="{
                            background: '#F3F4F7',
                            color: '#555',
                            padding: '5px 0'
                        }"
                        :cell-style="{ padding: '5px 0' }"
                        :span-method="arraySpanMethod"
                    >
                        <el-table-column prop="invoicesNo" :label="$t('invoicesCenter.detailOrderno')" align="center"> </el-table-column>
                        <el-table-column prop="packageSn" :label="$t('invoicesCenter.detailPackageno')" align="center">
                            <template slot-scope="scope">
                                <span
                                    @click="packageInfo(scope.row)"
                                    style="text-decoration: underline; color: #1890ff; cursor: pointer"
                                    >{{ scope.row.packageSn }}</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column prop="goodsNum" :label="$t('invoicesCenter.detailProductnum')" align="center"></el-table-column>
                        <el-table-column prop="senderInfoName" :label="$t('invoicesCenter.detailSender')" align="center"> </el-table-column>
                        <el-table-column prop="receiveInfoName" :label="$t('invoicesCenter.detailReceiver')" align="center"> </el-table-column>
                        <el-table-column prop="logisticsName" :label="$t('invoicesCenter.detailLogisticsname')" align="center"> </el-table-column>
                        <el-table-column prop="expressNo" :label="$t('invoicesCenter.detailExpressno')" align="center"> </el-table-column>
                        <el-table-column prop="state" :label="$t('invoicesCenter.detailStatus')" align="center">
                          <template slot-scope="scope">
                            <el-tag effect="dark"  v-if="scope.row.logisticsName && scope.row.logisticsName.indexOf('京东') !== -1">
                              {{ scope.row.jdStateDesc ? scope.row.jdStateDesc : $t('invoicesCenter.detailPendingupdate') }}
                            </el-tag>
                            <el-tag effect="dark" v-else :type="expressState[scope.row.state].type">
                              {{ scope.row.stateDesc }}
                            </el-tag>

                          </template>
                        </el-table-column>
                      <el-table-column prop="packingTime" :label="$t('invoicesCenter.detailPackfinishtime')" align="center" width="170"> </el-table-column>
                        <el-table-column prop="shipmentTime" :label="$t('invoicesCenter.detailShiptime')" align="center" width="170"> </el-table-column>
                        <el-table-column prop="signTime" :label="$t('invoicesCenter.detailSigntime')" align="center" width="170"> </el-table-column>
                        <el-table-column fixed="right" :label="$t('invoicesCenter.detailAction')" width="220px" align="center">
                            <template slot-scope="scope" style="display: flex">
                                <div style="display: flex;flex-wrap: wrap;">
                                    <el-button @click="clickPackage(scope.row)" type="text" size="small" style="margin-left: 10px;">
                                      <span style="text-decoration: underline">{{ $t('invoicesCenter.detailViewpackage') }}</span>
                                    </el-button>
                                    <el-button @click="handleClick(scope.row)" type="text" size="small">
                                        <span style="text-decoration: underline">{{ $t('invoicesCenter.detailLogisticstrack') }}</span>
                                    </el-button>
                                    <el-button @click="amendClick(scope.row)" type="text" size="small" v-if="scope.row.expressNo && type == 2">
                                        <span style="text-decoration: underline">{{ $t('invoicesCenter.detailModifyinfo') }}</span>
                                    </el-button>
                                  <el-button @click="printClick(scope.row)" type="text" size="small">
                                    <span style="text-decoration: underline">{{ $t('invoicesCenter.detailPrint') }}</span>
                                  </el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </section>

            <section class="section-card" v-if="differList.length">
              <h3 class="section-title">
                <span></span>
                <div>{{ $t('invoicesCenter.detailDiffinfo') }}</div>
              </h3>
              <div style="margin: 20px">
                <el-table
                    border
                    :data="differList"
                    :header-cell-style="{
                      background: '#F3F4F7',
                      color: '#555',
                      padding: '5px 0'
                    }"
                    :cell-style="{ padding: '5px 0' }">
                  <el-table-column prop="packageSn" :label="$t('invoicesCenter.detailPackageno')" align="center"></el-table-column>
                  <el-table-column prop="receiveName" :label="$t('invoicesCenter.detailConsignee')" align="center"></el-table-column>
                  <el-table-column prop="checkCompleteTime" :label="$t('invoicesCenter.detailReceivefinishtime')" align="center" width="200"></el-table-column>
                  <el-table-column prop="sendNum" :label="$t('invoicesCenter.detailProductnum')" align="center"></el-table-column>
                  <el-table-column prop="sendEpcNum" :label="$t('invoicesCenter.detailOutlabelnum')" align="center"></el-table-column>
                  <el-table-column prop="discrepancyNum" :label="$t('invoicesCenter.detailDifference')" align="center"></el-table-column>
                  <el-table-column prop="sendDutyNum" :label="$t('invoicesCenter.detailSenderduty')" align="center"></el-table-column>
                  <el-table-column prop="receiveDutyNum" :label="$t('invoicesCenter.detailReceiverduty')" align="center"></el-table-column>
                  <el-table-column prop="transportDutyNum" :label="$t('invoicesCenter.detailTransportduty')" align="center"></el-table-column>
                  <el-table-column prop="state" :label="$t('invoicesCenter.detailStatus')" align="center">
                    <template slot-scope="scope">
                      <el-tag
                          effect="dark"
                          size="mini"
                          :type="scope.row.state === '0' ? 'danger' : 'success'">
                        {{scope.row.state === '0' ? $t('invoicesCenter.detailUndetermined') : $t('invoicesCenter.detailDetermined')}}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" :label="$t('invoicesCenter.detailAction')" width="150">
                    <template slot-scope="scope">
                      <el-button @click="showDifferDetail(scope.row)" type="text" size="small">
                        <span style="text-decoration: underline">{{ $t('invoicesCenter.detailViewdetail') }}</span>
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </section>

            <section class="section-card" v-if="invoiceInvalidApplyInfoList.length">
              <h3 class="section-title">
                <span></span>
                <div>{{ $t('invoicesCenter.detailCancelapply') }}</div>
              </h3>
              <div style="margin: 20px;">
                <el-table
                    border
                    :data="invoiceInvalidApplyInfoList"
                    :header-cell-style="{
                                        background: '#F3F4F7',
                                        color: '#555',
                                        padding: '5px 0'
                                    }"
                    :cell-style="{ padding: '5px 0' }">
                  <el-table-column prop="applyUserName" :label="$t('invoicesCenter.detailApplicant')" align="center" width="180"> </el-table-column>
                  <el-table-column prop="applyTime" :label="$t('invoicesCenter.detailApplytime')" align="center" width="200"> </el-table-column>
                  <el-table-column prop="applyRemark" :label="$t('invoicesCenter.detailApplyreason')" align="center"> </el-table-column>
                  <el-table-column prop="state" :label="$t('invoicesCenter.detailStatus')" align="center" width="180">
                    <template slot-scope="scope">
                      <el-tag
                          effect="dark"
                          :type="scope.row.state == '0' ? 'warning' : scope.row.state == '1' ? 'success' : 'danger'">
                        {{scope.row.state == '0' ? $t('invoicesCenter.detailPendingapproval') : scope.row.state == '1' ? $t('invoicesCenter.detailApproved') : $t('invoicesCenter.detailRejected')}}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="checkUserName" :label="$t('invoicesCenter.detailApprover')" align="center" width="200"> </el-table-column>
                  <el-table-column prop="checkTime" :label="$t('invoicesCenter.detailApprovetime')" align="center" width="200"> </el-table-column>
                </el-table>
              </div>
            </section>
            <packageAndEpc
                v-if="packageModule"
                :detailList="detailLists"
                @close="packageModule = false"
            ></packageAndEpc>
            <TrackDialog v-if="disloagModule" :expressNo="expressNo" @close="disloagModule = false"></TrackDialog>
            <AllotPickUp v-if="type == 2 && CheckAcceptModule" :modalParams="modalParams" @close="checkClose"></AllotPickUp>
            <CheckAcceptPackDrawer
                v-if="type == 1 && CheckAcceptModule"
                :modalParams="drawerModalParams"
                @close="checkpackClose"
            >
            </CheckAcceptPackDrawer>
            <printDeliveryOrder
                v-if="printDialog"
                @close="printDialog = false"
                type="2"
                :modalParams="rowData"
                :isPrint="false"
            ></printDeliveryOrder>
            <entryCourierInfo
                v-if="entryCourierDialog"
                invoiceType="DCD"
                :modalParams="modalParams"
                :updateInfo="details"
                @close="entryCourier">
            </entryCourierInfo>
            <differDetailDialog v-if="isShowDiffer" :differRows="differRows" @close="isShowDiffer = false" @updateDiffer="fetchDifferList"></differDetailDialog>
            <el-dialog
                width="40%"
                append-to-body
                :title="$t('invoicesCenter.detailSelectpackage')"
                custom-class="pack-dialog"
                :visible.sync="packDialogShow"
                @close="packDialogShow = false">
                <el-table
                  border
                  :data="packOptions"
                  :row-class-name="tableRowClassName"
                  :header-cell-style="{
                    color: '#555',
                    padding: '5px 0',
                    background: '#e8e8e8'
                  }"
                  @row-click="handleSelectionChange">
                  <el-table-column :label="$t('invoicesCenter.detailSelect')" align="center" width="50" class="radios">
                    <template slot-scope="scope">
                      <el-radio class="radios" v-model="packageId" :label="scope.row.packageId" :disabled="scope.row.enableCheck === 'Y' ? false : true"></el-radio>
                    </template>
                  </el-table-column>
                  <el-table-column prop="packageSn" :label="$t('invoicesCenter.detailPackageno')" align="center"></el-table-column>
                  <el-table-column prop="expressSn" :label="$t('invoicesCenter.detailPackageexpressno')" align="center"></el-table-column>
                  <el-table-column prop="logisticsName" :label="$t('invoicesCenter.detailLogisticsname')" align="center"></el-table-column>
                  <el-table-column prop="state" :label="$t('invoicesCenter.detailAcceptstatus')" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.state === '0' ? $t('invoicesCenter.detailUnaccepted') : scope.row.state === '1' ? $t('invoicesCenter.detailAccepting') : $t('invoicesCenter.detailAccepted') }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="goodsNum" :label="$t('invoicesCenter.detailProductcount')" align="center"></el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer">
                  <el-button type="primary" size="small" @click="packConfirm">{{ $t('invoicesCenter.detailConfirm') }}</el-button>
                </div>
            </el-dialog>
          <InvoicePrint
            v-if="packagePrintDialog"
            :modalParams="packageList"
            documentType="DPDB"
            @close="packagePrintDialog = false"
          >
          </InvoicePrint>
        </section>
    </el-drawer>
</template>

<script>
import Timeline from '@/components/Timeline/index.vue'
import packageAndEpc from './packageEpcPh.vue'
import svgIcon from '@/components/SvgIcon/index'
import differDetailDialog from './differDetailDialog'
import TrackDialog from './trackDialog.vue'
import {
  erpMarketAllotQueryMarketAllotDetail,
  erp2MarketAllotQueryInvoicePackage,
  erp2OperatingInterceptExpress, queryDiscrepancyList
} from '@/libs/http/modules/erp.js'
import AllotPickUp from "../output/components/AllotPickUp.vue"
import CheckAcceptPackDrawer from '../input/components/CheckAcceptPackDrawer.vue'
import printDeliveryOrder from './printDeliveryOrder.vue'
import entryCourierInfo from './entryCourierInfo.vue'
import SizeGroupTable from '@/components/SizeGroupTable/index.vue'
import { columnObj, sizeInfoLabel, footerObj } from './tableConfig.js'
import InvoicePrint from "@/components/packagePrintInvoices/index.vue";
import cache from "@/libs/common/cache.js";

export default {
    name: 'ShopDetails',
    props: {
        modalParams: {
            type: Object,
            default: () => null
        },

        type: {
            type: String,
            default: '1'
        }
    },
    components: {
      InvoicePrint,
        TrackDialog,
        AllotPickUp,
        printDeliveryOrder,
        entryCourierInfo,
        CheckAcceptPackDrawer,
        SizeGroupTable,
        differDetailDialog,
        packageAndEpc,
        svgIcon,
        Timeline,
        StatusTag: () => import('@/components/StatusTag/index.vue')
    },
    data() {
        return {
            columnObj,
            sizeInfoLabel,
            footerObj,
            dialogVisible: false,
            CheckAcceptModule: false,
            entryCourierDialog: false,
            drawerType: 1,
            details: [],
            dataList: [],
            invoicesData: null,
            invoicesSnType: '',
            logisticsList: [],
            courierInfoDialog: false,
            scheduleInfoList: [],
            scheduleState: 2,
            disloagModule: false,
            rowData: null,
            printDialog: false,
            expressNo: null,
            packDialogShow: false,
            loading: false,
          packagePrintDialog:false,
            packageId: '',
            packOptions: [],
            drawerModalParams: {},
          invoiceInvalidApplyInfoList:[],
          expressState: {
            0: {
              type: 'warning'
            },
            1: {
              type: 'warning'
            },
            2: {
              type: 'info'
            },
            3: {
              type: 'info'
            },
            4: {
              type: 'success'
            }
          },
          differList: [],
          differRows: null,
          isShowDiffer: false,
          packageModule: false,
          detailLists: [],
          packageList:[],
        }
    },
    computed: {
        newSizeInfoLabels() {
            return this.formatLabels(this.sizeInfoLabel['DB'])
        },
        newFooterOptions() {
            return this.footerObj['DB']
        },
        newColumns() {
            return this.columnObj['DDDB']
        }
    },
    mounted() {
        this.fetchDetail()
        this.fetchDifferList()
    },
    methods: {
      printClick(row) {
        this.packagePrintDialog=true
        row.sn=this.modalParams.sn
        this.packageList=[row]
      },
        formatLabels(arr) {
            return arr.map((item, index) => {
                if (index === 0) {
                    item.disabled = false
                    item.value = this.scheduleState >= 1 ? true : false
                } else if ([1, 2].includes(index)) {
                    item.disabled = this.scheduleState >= 2 ? false : true
                    item.value = this.scheduleState >= 2 ? true : false
                } else if ([3, 4].includes(index)) {
                    item.disabled = this.scheduleState > 3 ? false : true
                    item.value = this.scheduleState > 3 ? true : false
                }
                return item
            })
        },
        checkClose(e) {
            this.CheckAcceptModule = false
            if (e) {
                this.$parent.refresh(e)
                this.modalParams.state = 6
                this.fetchDetail()
            }
            // this.$par('refresh', true)
            // this.$parent.refresh(e)
        },
        checkpackClose(e) {
            this.CheckAcceptModule = false
            if (e) {
                this.$parent.refresh(e)
                this.fetchDetail()
            }
        },
        clickPackage(row) {
          this.packageModule = true
          this.detailLists = row
        },
        packageInfo(row) {
            this.printDialog = true
            row.invoicesId = this.modalParams.invoicesId
            this.rowData = row
        },
        close() {
            this.dialogVisible = false
            this.$emit('close')
        },
        checkAcceptClick() {
            if(this.type == 2 && this.modalParams['rfidAllotOutSwitch'] === 'Y'){
              return this.$message({ type: 'error', message: this.$t('invoicesCenter.detailUsepda'), duration: 2000, showClose: true })
            }
            this.CheckAcceptModule = true
        },
        fetchDetail() {
            this.loading = true
            this.dialogVisible = true
            erpMarketAllotQueryMarketAllotDetail({
                id: this.modalParams.id
            })
                .then((data) => {
                    this.loading = false
                    this.invoicesData = data.invoicesInfo
                    this.modalParams.state = data.invoicesInfo.state // 更新状态
                    this.invoicesSnType = data.invoicesInfo.invoicesSn.slice(0, 2) || 'PH'
                    this.$nextTick(() => {
                        this.dataList = data.goodsInfoList || []
                    })
                    this.invoiceInvalidApplyInfoList = data.invoiceInvalidApplyInfoList || []
                    this.logisticsList = data.logisticsList || []
                    this.scheduleInfoList = data.scheduleInfoList || []
                    this.scheduleState = Number(data.scheduleState)
                })
                .catch((err) => {
                    this.loading = false
                    this.$message({
                        type: 'error',
                        message: err,
                        duration: 2000,
                        showClose: true
                    })
                })
        },
        getSpanArr(data, spanKey) {
            let spanArr = [] //值
            let pos = '' //下标
            for (let i = 0; i < data.length; i++) {
                if (i === 0) {
                    spanArr.push(1)
                    pos = 0
                } else {
                    // 判断当前元素与上一个元素是否相同
                    if (data[i][spanKey] === data[i - 1][spanKey]) {
                        spanArr[pos] += 1
                        spanArr.push(0)
                    } else {
                        spanArr.push(1)
                        pos = i
                    }
                }
            }
            return spanArr
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            let currindex = [0, 3, 4, 5, 6, 7,9,10]
            if (currindex.indexOf(columnIndex) != -1) {
                let spanArr = this.getSpanArr(this.logisticsList, row.invoicesNo)
                const _row = spanArr[rowIndex]
                const _col = _row > 0 ? 1 : 0
                return {
                    rowspan: _row,
                    colspan: _col
                }
            }
        },
        handleClick(row) {
            row.invoicesId = this.modalParams.invoicesId
            this.expressNo = row
            this.disloagModule = true
        },

        amendClick(row) {
            if (row.type == '1') {
                this.$confirm(this.$t('invoicesCenter.detailCancelexpress'), {
                    type: 'warning'
                })
                    .then(() => {
                        erp2OperatingInterceptExpress({
                            id: row.packageId
                        })
                            .then((data) => {
                                this.$message.success(this.$t('invoicesCenter.detailCancelsuccess'))
                                this.$nextTick(() => {
                                    this.fetchDetail()
                                })
                                this.entryCourierDialog = true
                                this.details ={ ...row, packageIds: [row.invoicesLogisticsInfoId] }
                            })
                            .catch((err) => {
                                this.$message({
                                    type: 'error',
                                    message: err,
                                    duration: 2000,
                                    showClose: true
                                })
                            })
                    })
                    .catch(() => {})
            }
            if (row.type == '2') {
                this.entryCourierDialog = true
                const list = this.logisticsList.map(item=>{
                  return item.packageId
                })
                this.details = { ...row, packageIds: list }
            }
        },
        entryCourier(refetch) {
            this.entryCourierDialog = false
            if (refetch) {
                this.fetchDetail()
            }
        },

        checkGet() {
            if (this.type == 1) {
                if(this.modalParams['rfidInvoicePack'] === 'Y' && this.modalParams['rfidAllotInputSwitch'] === 'Y'){
                  this.$confirm(this.$t('invoicesCenter.detailRfidnotice'), this.$t('invoicesCenter.detailTip'), {
                    showClose: false,
                    showCancelButton: false,
                    closeOnClickModal: false,
                    confirmButtonClass: false,
                    confirmButtonText: this.$t('invoicesCenter.detailGotit')
                  }).then(res=>{

                  }).catch(()=>{})
                  return
                }
                this.getPackOptions()
            } else {
                this.CheckAcceptModule = true
            }
        },

        handleSelectionChange(row) {
          if(row.enableCheck === 'N') {
            return this.$message.warning(this.$t('invoicesCenter.detailPackageaccepted'))
          }
          this.packageId = row.packageId
        },
        tableRowClassName({ row, columnIndex }) {
          if(row.enableCheck === 'N') {
            return 'warning-row'
          }
          return 'unwarning-row'
        },
        packConfirm() {
            if (!this.packageId) {
              return this.$message.error(this.$t('invoicesCenter.detailChoosepackage'))
            }
            this.packDialogShow = false
            this.CheckAcceptModule = true
            this.drawerModalParams = { packageId: this.packageId }
        },
        getPackOptions() {
            let reqData = {
                id: this.modalParams.id
            }
            erp2MarketAllotQueryInvoicePackage(reqData).then((data) => {
                if (data.itemList.length > 1) {
                    this.packageId = ''
                    this.packOptions = data.itemList
                    this.packDialogShow = true
                } else {
                    this.drawerModalParams = data.itemList[0]
                    this.CheckAcceptModule = true
                }
            }).catch((err) => {
                this.$message({ type: 'error', message: err, duration: 2000, showClose: true })
            })
        },
        fetchDifferList(){
          queryDiscrepancyList({
            page: '1',
            pageSize: '100',
            queryText: this.modalParams.sn
          }).then(res=>{
            console.log(res)
            this.differList = res.items || []
          }).catch(error=>{})
        },
        showDifferDetail(row){
          this.differRows = row
          this.isShowDiffer = true
        }
    }
}
</script>

<style lang="scss" scoped>
.dialog-top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    p {
        font-size: 18px;
        color: #333;
    }

    div i {
        cursor: pointer;
        font-size: 22px;
        margin-left: 20px;
        float: right;
        margin-top: 8px;
    }

    .sub-box {
        color: black;
        margin: 10px 15px;
        padding: 10px 50px;
        background: #c6e7ff;
        display: flex;
        justify-content: center;
        align-content: center;
        cursor: pointer;
        border-radius: 3px;

        img {
            width: 20px;
            margin-right: 10px;
        }
    }
}

.step {
    width: 100%;
    padding-bottom: 50px;
}

.section-card {
    position: relative;
    margin-bottom: 30px;
    .text-link {
        color: #1890ff;
        cursor: pointer;
    }

    .section-title {
        font-size: 18px;
        color: #333;
        font-weight: normal;
        display: flex;
        align-items: center;

        span {
            margin-top: -2px;
            width: 4px;
            height: 18px;
            background: #067cf2;
            margin-right: 16px;
            border-radius: 0 2px 2px 0;
        }
    }

    > div {
        margin: 20px;
    }

    .detail-state {
        position: absolute;
        right: 20px;
        top: -50px;

        img {
            width: 80px;
        }
    }

    .section-value {
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;

        > div {
            width: calc(100% / 3);
            margin-bottom: 10px;
        }
    }
}

.size-icon {
    margin-right: 5px;
    margin-top: 3px;
}


::v-deep .radios .el-radio__label{
  display: none;
}
::v-deep .el-table .warning-row {
  color: #b0afac !important;
  background: #f5f7fa!important;
}
::v-deep .el-table .unwarning-row {
  color: red !important;
}
</style>
